<template>
  <b-skeleton-wrapper :loading="loading">
    <template v-slot:loading>
      <div
        v-for="item in items"
        :key="uniqueId('base-radiolist-skeleton-item')"
        class="d-flex align-items-center"
      >
        <b-skeleton
          width="15px"
          height="15px"
          type="avatar"
          animation="fade"
          class="mr-2"
        ></b-skeleton>

        <b-skeleton
          :width="`${item}%`"
          height="22px"
          animation="fade"
        ></b-skeleton>
      </div>
    </template>

    <slot />
  </b-skeleton-wrapper>
</template>

<script>
import { defineComponent, computed, inject } from '@vue/composition-api'
import { uniqueId } from 'lodash-es'

export default defineComponent({
  name: 'BaseRadiolistSkeleton',
  setup() {
    const { loading } = inject('base-radiolist')

    const items = computed(() =>
      Array.from({ length: 5 }, () => {
        const value = Math.floor(Math.random() * 50)

        return 15 > value ? 15 : value
      })
    )

    return {
      uniqueId,

      loading,

      items
    }
  }
})
</script>
